export default __webpack_public_path__ + "static/media/secondOptionNDA.png?.e849b150";